import { render, staticRenderFns } from "./TerminalCard.vue?vue&type=template&id=60c7140d&scoped=true&"
import script from "./TerminalCard.vue?vue&type=script&lang=js&"
export * from "./TerminalCard.vue?vue&type=script&lang=js&"
import style0 from "./TerminalCard.vue?vue&type=style&index=0&id=60c7140d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c7140d",
  null
  
)

export default component.exports